

class PictureTeaserVideo {

  private selector: HTMLElement;
  private video: HTMLVideoElement;

  constructor(selector: HTMLElement) {
    this.selector = selector;
  }

  init() {
    this.cache();
    this.bindings();
  }
  cache() {
    this.video = this.selector.querySelector('.js-m-picture-taser__video') as HTMLVideoElement;
  }
  bindings() {
    const { video } = this;
    if (video) {
      video.addEventListener('mouseenter', (e: MouseEvent) => this.startVideo());
      video.addEventListener('mouseleave', (e: MouseEvent) => this.stopVideo());
    }
  }

  private startVideo() {
    const { video } = this;
    video.classList.add('is-visible');
    video.play();
  }

  private stopVideo() {
    const { video } = this;
    video.classList.remove('is-visible');
    video.pause;
    setTimeout(() => {
      video.currentTime = 0;
    }, 400);
  }
}

export default PictureTeaserVideo;
